import {
  useRenewalsByCustomer,
  useRenewalsByQuarter,
  useRenewalsCustomers,
} from "../../hook/partner/renewals.partner.hook";
import { useEffect, useState } from "react";
import { useAuthStore } from "../../store/auth.store";
import { useRenewalsStore } from "../../store/renewals.store";
import RenewalOfferModal from "../../components/modals/renewal/RenewalOfferModal";
import { Accordion } from "react-bootstrap";

export default function RenewalsByCustomer() {
  const renewalsMutation = useRenewalsByCustomer();
  const customersMutation = useRenewalsCustomers();
  const [page, setPage] = useState(0);
  const [openDetail, setOpenDetail] = useState(0);

  const [showModal, setShowModal] = useState(false);

  const token = useAuthStore((state) => state.token);
  const renewals = useRenewalsStore((state) => state.renewalsByCustomer);
  const customers = useRenewalsStore((state) => state.customers);
  const clearRenewals = useRenewalsStore((state) => state.clearRenewals);

  useEffect(() => {
    clearRenewals();
    customersMutation.mutate({ token });
  }, []);

  useEffect(() => {
    if (page !== 0) {
      renewalsMutation.mutate({ company_id: page, token });
    }
  }, [page, token]);

  useEffect(() => {
    if (customers?.length > 0) {
      setPage(customers[0]["company_id"]);
    }
  }, [customers]);

  if (customersMutation.isLoading || renewalsMutation.isLoading) {
    return <>Načítání</>;
  }
console.log(renewals)
  return (
    <>
      <div className="d-md-none">
        <Accordion>
          {customers?.map((customer, ckey) => (
            <Accordion.Item eventKey={ckey} key={ckey}>
              <Accordion.Header onClick={() => setPage(customer.company_id)}>
                {customer.name}
              </Accordion.Header>
              <Accordion.Body>
                {customer.company_id == page ? (
                  customersMutation.isLoading ? (
                    <div className="alert alert-into">Nahrávám...</div>
                  ) : (
                    <>
                      {renewals?.map((renewal, rindex) => (
                        <div className="card mb-5">
                          <div className="card-header">
                            <h3 className="card-title">
                              {new Date(
                                renewal.expire_date
                              ).toLocaleDateString()}
                              <span className="ms-4 badge badge-info badge-outline">
                                {renewal.vendor}
                              </span>
                            </h3>
                          </div>
                          <div className="card-body">
                            <div className="row">
                              <div className="col-12 mb-3">
                                <strong>Celkem</strong>
                                <div>{renewal.quantity}</div>
                              </div>
                              <div className="col-6 mb-3">
                                <strong>V řešení</strong>
                                <div>
                                  {renewal.quantity_renewal == 0 ? (
                                    <span class="badge badge-primary">
                                      {renewal.quantity_renewal}
                                    </span>
                                  ) : (
                                    renewal.quantity_renewal
                                  )}
                                </div>
                              </div>
                              <div className="col-6 mb-3">
                                <strong>Obnovujeme</strong>
                                <div>
                                  {renewal.quantity_renewal_progress > 0 ? (
                                    <span class="badge badge-warning">
                                      {renewal.quantity_renewal_progress}
                                    </span>
                                  ) : (
                                    renewal.quantity_renewal_progress
                                  )}
                                </div>
                              </div>
                              <div className="col-6 mb-3">
                                <strong>Obnoveno</strong>
                                <div>
                                  {renewal.quantity_renewal_done > 0 ? (
                                    <span class="badge badge-success">
                                      {renewal.quantity_renewal_done}
                                    </span>
                                  ) : (
                                    renewal.quantity_renewal_done
                                  )}
                                </div>
                              </div>
                              <div className="col-6 mb-3">
                                <strong>Bez obnovy</strong>
                                <div>
                                  {renewal.quantity_renewal_lost > 0 ? (
                                    <span class="badge badge-secondary">
                                      {renewal.quantity_renewal_lost}
                                    </span>
                                  ) : (
                                    renewal.quantity_renewal_lost
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="card-footer">
                            <button
                              className="btn btn-primary btn-sm w-100"
                              data-bs-toggle="modal"
                              data-bs-target="#renewal-offer-modal"
                              onClick={() =>
                                setOpenDetail({
                                  ...renewal,
                                  company_id: page,
                                })
                              }
                            >
                              Detail
                            </button>
                          </div>
                        </div>
                      ))}
                    </>
                  )
                ) : (
                  "---"
                )}
              </Accordion.Body>
            </Accordion.Item>
          ))}
        </Accordion>
      </div>
      <div className="d-none d-md-block">
        <div className="row">
          <div className="col-12 col-md-3">
            <div className="menu menu-rounded menu-column menu-gray-600 menu-state-bg fw-semibold">
              {customersMutation.isLoading ? (
                <p>Načítání</p>
              ) : (
                <>
                  {customers?.length > 0 &&
                    customers?.map((customer, ckey) => (
                      <div className="menu-item" key={ckey}>
                        <span
                          onClick={() => setPage(customer.company_id)}
                          className={
                            "cursor-pointer menu-link " +
                            (customer.company_id == page ? "active" : "")
                          }
                        >
                          {customer.name}
                        </span>
                      </div>
                    ))}
                </>
              )}
            </div>
          </div>
          <div className="col-12 col-md-9">
            {renewalsMutation.isLoading ? (
              <p>Načítání</p>
            ) : (
              <>
                {!renewals || renewals?.length === 0 ? (
                  <p>Nenalezeno</p>
                ) : (
                  <div className="dt-container dt-bootstrap5 dt-empty-footer">
                    <div id="" className="table-responsive">
                      <table
                        className="table align-middle table-bordered fs-6 gy-5 xxxdataTable"
                        style={{ width: "100%" }}
                      >
                        <thead>
                          <tr className="text-start align-middle text-gray-500 fw-bold fs-7 text-uppercase gs-0">
                            <th rowSpan="2">Výrobce</th>
                            <th rowSpan="2">Datum expirace</th>
                            <th colSpan="5">Počet licencí</th>
                            <th rowSpan="2"></th>
                          </tr>
                          <tr className="text-start align-middle text-gray-500 fw-bold fs-7 text-uppercase gs-0">
                            <th>Celkem</th>
                            <th>V řešení</th>
                            <th>Obnovujeme</th>
                            <th>Obnoveno</th>
                            <th>
                              Nebudeme
                              <br />
                              obnovovat
                            </th>
                          </tr>
                        </thead>
                        <tbody className="fw-semibold text-gray-600">
                          {renewals.map((renewal, rindex) => (
                            <tr key={rindex}>
                              <td>{renewal.vendor}</td>
                              <td>
                                {new Date(
                                  renewal.expire_date
                                ).toLocaleDateString()}
                              </td>
                              <td>{renewal.quantity}</td>
                              <td>
                                {renewal.quantity_renewal == 0 ? (
                                  <span class="badge badge-primary">
                                    {renewal.quantity_renewal}
                                  </span>
                                ) : (
                                  renewal.quantity_renewal
                                )}
                              </td>
                              <td>
                                {renewal.quantity_renewal_progress > 0 ? (
                                  <span class="badge badge-warning">
                                    {renewal.quantity_renewal_progress}
                                  </span>
                                ) : (
                                  renewal.quantity_renewal_progress
                                )}
                              </td>
                              <td>
                                {renewal.quantity_renewal_done > 0 ? (
                                  <span class="badge badge-success">
                                    {renewal.quantity_renewal_done}
                                  </span>
                                ) : (
                                  renewal.quantity_renewal_done
                                )}
                              </td>
                              <td>
                                {renewal.quantity_renewal_lost > 0 ? (
                                  <span class="badge badge-secondary">
                                    {renewal.quantity_renewal_lost}
                                  </span>
                                ) : (
                                  renewal.quantity_renewal_lost
                                )}
                              </td>
                              <td>
                                <button
                                  className="btn btn-primary"
                                  onClick={() => {
                                    setShowModal(true);
                                    setOpenDetail({
                                      ...renewal,
                                      company_id: page,
                                    });
                                  }}
                                >
                                  Detail
                                </button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      </div>
      <RenewalOfferModal
        show={showModal}
        handleClose={() => setShowModal(false)}
        renewal={openDetail}
        title={openDetail?.vendor}
      />
    </>
  );
}
